import React from "react";
import {AlertInformation} from "../../AlertInformation/AlertInformation";

interface UnverifiedTransferWarningProps {
	isVisible: boolean;
}

const UnverifiedTransferWarning: React.FC<UnverifiedTransferWarningProps> = ({ isVisible }) => {
    if (!isVisible) return null;
    
    return (
        <AlertInformation
            severity="warning"
            message="We can't verify the sent quantities for this transfer yet, but you can scan it as normal!"
            title="Unverified Transfer Quantities"
        />
    );
};

export default UnverifiedTransferWarning;
